import React from 'react';

import PropTypes from 'prop-types';

import { TagSquare } from '@src/components/atoms/tag-square';
import { Heading15 } from '@src/theme';
import { bemClassName } from '@src/utils/bem';

import { StyledTagsCloud } from './styles';

const b = bemClassName('tags-cloud');

const TagsCloud = ({ title, tags, onTagClick, clickable = false }) => {
  return (
    <StyledTagsCloud>
      <div className={b()}>
        <div className={b('title')}>
          <Heading15>{title}</Heading15>
        </div>
        <div className={b('content')}>
          {tags.map((tag, index) => (
            <div key={`popular-tag-item-${index}`} className={b('content', 'item')}>
              <TagSquare text={tag} onClick={() => onTagClick?.(tag)} clickable={clickable} />
            </div>
          ))}
        </div>
      </div>
    </StyledTagsCloud>
  );
};

TagsCloud.propTypes = {
  title: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  onTagClick: PropTypes.func,
  clickable: PropTypes.bool,
};

export default TagsCloud;
